import { cn } from "@utils/tw"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

export const Chip = ({
  children,
  variant = "dark",
  size = "default",
  className,
}: {
  children: ReactNode
  variant?: "dark" | "light" | "gray" | "ghost"
  size?: "default" | "sm"
  className?: string
}) => {
  return (
    <div
      className={twMerge(
        "type-label-s-light w-fit flex justify-center items-center",
        variant === "dark" && "bg-black text-white",
        variant === "light" && "bg-white text-black",
        variant === "gray" && "bg-secondary text-black",
        size === "default" && "px-2 py-1",
        size === "sm" && "px-1 py-0",
        className,
      )}
    >
      <span className={cn("block mt-[0.3em]", size === "sm" && "text-[0.75em]")}>{children}</span>
    </div>
  )
}
